var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5242 2 22 6.47581 22 12C22 17.5242 17.5242 22 12 22C6.47581 22 2 17.5242 2 12C2 6.47581 6.47581 2 12 2ZM10.8347 7.79032L13.879 10.7097H6.51613C5.97984 10.7097 5.54839 11.1411 5.54839 11.6774V12.3226C5.54839 12.8589 5.97984 13.2903 6.51613 13.2903H13.879L10.8347 16.2097C10.4435 16.5847 10.4355 17.2097 10.8185 17.5927L11.2621 18.0323C11.6411 18.4113 12.254 18.4113 12.629 18.0323L17.9798 12.6855C18.3589 12.3065 18.3589 11.6935 17.9798 11.3185L12.629 5.96371C12.25 5.58468 11.6371 5.58468 11.2621 5.96371L10.8185 6.40323C10.4355 6.79032 10.4435 7.41532 10.8347 7.79032Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.d8b309066081348dfe61ae4e1e4b5bb2.svg";
export { ForwardRef as ReactComponent };